// The desktop app's title strip without the console (the sign-in entry draws it too, so it reads nothing of the
// session): the GridController mark over the top of the page, the drag area, the system buttons' strip kept free on
// its right, or its left on macOS (ui.css html.gc-frame). Shown only in the shell's custom frame (engine/desktop.ts).

import { BoltMark } from './BoltMark';
import { desktopInfo } from '../../engine/desktop';

export const customFrame = desktopInfo()?.frame === 'custom';

export function TitleStripView() {
  if (!customFrame) return null;
  return (
    <div className="gc-titlestrip gc-drag pointer-events-auto fixed left-0 right-0 top-0 z-[200] flex items-center gap-2 pl-3" aria-hidden>
      <BoltMark size={16} />
      <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-t2">GridController</span>
    </div>
  );
}
